import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  drugs: [],
  allDrugs: [],
  totalPages: 0,
  totalRecords: 0,
  drug: null,
  errorStatus: null,
  drugDetail: null,
};
const getters = {
  getApiLoad_23: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Drugs(state, drugs) {
    state.drugs = drugs.items;
    state.totalPages = drugs.totalPages;
    state.totalRecords = drugs?.totalRecords ?? 0;
  },
  SET_AllDrugs(state, drugs) {
    state.allDrugs = drugs;
  },
  SET_Drug(state, drug) {
    state.drug = drug;
  },
  SET_DrugDetail(state, drug) {
    state.drugDetail = drug;
  },
};
const actions = {
  errorDrug({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllDrugs({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Drugs/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllDrugs', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrug', error);
      });
  },
  getAllDrugsWithGroupId({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Drugs/All?DrugGroupId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllDrugs', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrug', error);
      });
  },
  getDrugsWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, code, drugGroupId, unitId },
  ) {
    var url = '/Drugs/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (code) {
      url += '&Code=' + code;
    }
    if (unitId) {
      url += '&UnitId=' + unitId;
    }
    if (drugGroupId) {
      url += '&DrugGroupId=' + drugGroupId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Drugs', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrug', error);
      });
  },
  addDrug({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Drugs', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrug', error);
      });
  },
  getDrug({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Drugs/ById?drugId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Drug', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrug', error);
      });
  },
  getDrugDetail({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Drugs/ByIdWithDetails?drugId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DrugDetail', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrug', error);
      });
  },
  editDrug({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Drugs/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrug', error);
      });
  },
  deleteDrug({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Drugs/Remove?drugId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrug', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
